import { ChangeEvent, FC, useEffect, useState } from 'react'
import { useVisibility } from 'hooks'
import { useStoreActions, useStoreState } from 'store'
import Arrow from 'components/shared/icons/Arrow'
import NumberFormat from 'react-number-format'

interface Props {
  index?: number
}

/**
 * Branded Lead Form Row
 */

const url = `https://${
  process.env.REACT_APP_ENV === 'production' ? 'offers.bankrate.com' : 'offers.qa.bankrate.com'
}/mortgages/br-branded`

const BrandedRowV2: FC<Props> = ({ index }) => {
  const [isVisible, element] = useVisibility()
  const { onClickTracking, onViewedTracking } = useStoreActions(actions => actions.tracking)
  const [isViewed, setIsViewed] = useState(false)

  const globalZipCode = useStoreState(state => state.dimensions.dimensions.zipCode)
  const [localZipCode, setLocalZipCode] = useState(globalZipCode)

  useEffect(() => {
    if (isVisible && !isViewed) {
      setIsViewed(true)
      onViewedTracking({
        element: {
          type: 'banner',
          htmlId: '',
          location: 'rate table',
          name: 'low coverage banner',
          position: 'middle',
          text: 'Find the top mortgages near you',
        },
      })
    }
  }, [isVisible, isViewed, onViewedTracking])

  const onChange = async (event: ChangeEvent<HTMLInputElement>) => {
    setLocalZipCode(event.target.value)
  }

  const onCtaClick = () => {
    onClickTracking({
      element: {
        type: 'button',
        htmlId: '',
        location: 'rate table',
        name: 'low coverage banner',
        position: 'middle',
        text: 'Find my rates',
      },
      outcome: 'INTERNALLINK',
    })
  }

  return (
    <tr key={index} data-testid={`brandedRow-${index}`} className="rate-table__row --branded" ref={element}>
      <td className="px-0 py-0 md:py-4" colSpan={5}>
        <div
          data-testid="branded-banner"
          className="bg-gray-light display-flex justify-content-space-between flex-direction-column md:flex-direction-row align-items-center p-6 md:p-8"
        >
          <div className="mb-4 md:mb-0">
            <p className="type-heading-two text-black mb-4 text-center md:text-left">Find the top mortgages near you</p>
            <ul className="List List--checkmark text-left type-body-one text-slate mb-0">
              <li>Get accurate quotes from both traditional and digital lenders</li>
              <li>Get custom mortgage quotes online in under 2 minutes</li>
              <li>No credit checks required to get quotes.</li>
            </ul>
          </div>
          <div className="md:ml-8 w-full md:w-auto">
            <form method="get" action={url} target="_blank">
              <div className="FormControl mb-4 w-full" style={{ minWidth: 270 }}>
                <label className="FormLabel text-left" htmlFor="brandedRowZipCode">
                  Zip code
                </label>
                <NumberFormat
                  name="zipCode"
                  value={localZipCode}
                  onChange={onChange}
                  data-testid="brandedRowZipCode"
                  className="FormInput"
                  id="brandedRowZipCode"
                  inputMode="numeric"
                  pattern="[0-9,]*"
                  allowLeadingZeros={true}
                />
              </div>
              <div>
                <button
                  type="submit"
                  data-testid="branded-row-cta-button"
                  className="Button Button--secondary w-full bg-transparent"
                  onClick={onCtaClick}
                >
                  Find my rates
                  <Arrow style={{ height: '1.25em', verticalAlign: 'sub' }} />
                </button>
              </div>
            </form>
          </div>
        </div>
      </td>
    </tr>
  )
}

export default BrandedRowV2
